import { render, staticRenderFns } from "./StandardList.vue?vue&type=template&id=66eb138a&scoped=true"
import script from "./StandardList.vue?vue&type=script&lang=js"
export * from "./StandardList.vue?vue&type=script&lang=js"
import style0 from "./StandardList.vue?vue&type=style&index=0&id=66eb138a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eb138a",
  null
  
)

export default component.exports